/**
 * TA 的心愿来信「点开去哪」（UI-MSGLINK-01，6c2b 2026-10-13；后端 MessageSummary.link，B 的 MESSAGE-LINK-KIND-01 把 kind 收窄成 wish | plan）。
 * 后端只给 kind 和 ref、不给 URL，路径由前端按 kind 拼（契约原话「路径由前端按 kind 拼，后端不下发 URL」）：
 * - wish（心愿形成那封）：去心愿页 /guides/wish——那一页看的是 TA 现在的心愿；
 * - plan（计划就绪那封）：去这份计划 /guides/plan/{ref}。
 * 认不出的 kind、没有 ref 的 plan：不出链接，不猜路径。
 */
import type { MessageLink } from "@/shared/contracts";

export type MessageLinkKind = "wish" | "plan";
export type MessageLinkTarget = { kind: MessageLinkKind; to: string; label: string };

export function messageLinkTarget(link: MessageLink | null | undefined): MessageLinkTarget | null {
  if (!link) return null;
  if (link.kind === "wish") return { kind: "wish", to: "/guides/wish", label: "看看这个心愿" };
  if (link.kind === "plan" && typeof link.ref === "string" && link.ref.trim() !== "") return { kind: "plan", to: `/guides/plan/${encodeURIComponent(link.ref)}`, label: "看看这份计划" };
  return null;
}
